export const fetchMedia = async (url: string) => {
  return fetch(url, {credentials: 'omit'});
};
